import { Popover } from 'foundations-components/transitional/components/Popover';
import { H5 } from 'foundations-components/transitional/components/H5';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useContext, useEffect, useState } from 'react';
import SegmentationFiltersInstanceContext from 'customer-data-filters-ui/state/SegmentationFiltersInstanceContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConditionBoxDeletePopover = props => {
  const {
    children,
    onConfirm,
    onCancel,
    isOpen
  } = props;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const {
    props: {
      uiMessages: {
        conditionDeletePopoverHeader,
        conditionDeletePopoverDescription
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  useEffect(() => {
    if (isOpen) {
      setIsPopoverOpen(true);
    }
  }, [isOpen]);
  const onConfirmLocal = useCallback(event => {
    event.stopPropagation();
    setIsPopoverOpen(false);
    onConfirm();
  }, [onConfirm]);
  const onCancelLocal = useCallback(event => {
    event.stopPropagation();
    setIsPopoverOpen(false);
    onCancel();
  }, [onCancel]);
  const onOpenChange = useCallback(evt => {
    setIsPopoverOpen(evt.target.value);
    if (!evt.target.value) {
      onCancel();
    }
  }, [onCancel]);
  return /*#__PURE__*/_jsx(Popover, {
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: conditionDeletePopoverHeader || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.conditionDeletePopoverHeader"
        })
      }),
      body: conditionDeletePopoverDescription || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.filtersViewer.conditionDeletePopoverBody"
      }),
      footer: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onConfirmLocal,
          size: "sm",
          use: "danger",
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.conditionDeletePopoverConfirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onCancelLocal,
          size: "sm",
          use: "tertiary-light",
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.conditionDeletePopoverCancel"
          })
        })]
      })
    },
    open: isPopoverOpen,
    placement: "right",
    inlineSize: "330px",
    onOpenChange: onOpenChange,
    children: children
  });
};
export default ConditionBoxDeletePopover;